@value headerHeight from '../sidebar/sidebar-header.module.css';

.content-container {
    height: calc(100% - headerHeight);
}
